export const eventsActionTypes = {
    setData: 'EVENTS_SET_DATA',
};

const initialState = {
    oldEvents: [],
    newEvents: {},
    stats: {
        total: 0,
        success: 0,
    },
    checksComplete: false,
    canDismissEvents: false,
    errorsPresentButHidden: false,
};

export default function events(state = initialState, action) {
    switch (action.type) {
        case eventsActionTypes.setData:
            return {
                ...state,
                ...action.data,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/events.js